module.exports = __webpack_public_path__ + "static/alva-students-a612fb0af89a9d5554c592112b979320.jpg";